
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"8","fill":"none"}},[_c('path',{attrs:{"stroke":"#E2E8EF","d":"M1.187 4.287L3.88 6.98M3.186 6.968l6.282-5.834"}})])
      }
    
      }
    